module.exports = __webpack_public_path__ + "static/media/avc_height.9896d383.svg";